import { RequestStatusEnum } from "@/lib/enum/request-status-enum";

/**
 * How a lead status is drawn.
 *
 * Kept out of the entity so a presentational component can look up the appearance of a status other
 * than the one the lead currently holds — the customer's card draws the outcome an offer reached
 * rather than the workshop's later closure — without importing the entity, which pulls the whole
 * paginated-store graph in with it.
 *
 * Colors and icons - based on @see SIGN_COLOR_BY_STATUS
 */
export const LEAD_STATUS_COLOR: ReadonlyMap<RequestStatusEnum, string> = new Map([
  [RequestStatusEnum.DRAFT, "grey"],
  [RequestStatusEnum.REQUESTED, "primary"],
  [RequestStatusEnum.REPLIED, "green lighten-2"],
  [RequestStatusEnum.ACCEPTED, "green"],
  [RequestStatusEnum.REJECTED_BY_REQUESTED, "red"],
  [RequestStatusEnum.REJECTED_BY_REQUESTING, "red"],
  [RequestStatusEnum.REQUEST_MORE_DATA, "orange"],
  [RequestStatusEnum.FINISHED, "deep-purple lighten-1"]
]);

export const LEAD_STATUS_ICON: ReadonlyMap<RequestStatusEnum, string> = new Map([
  [RequestStatusEnum.DRAFT, "mdi-file-document-outline"],
  [RequestStatusEnum.REQUESTED, "mdi-file-send-outline"],
  [RequestStatusEnum.REPLIED, "mdi-file-document-outline"],
  [RequestStatusEnum.REQUEST_MORE_DATA, "mdi-message-question-outline"],
  [RequestStatusEnum.ACCEPTED, "mdi-check-circle-outline"],
  [RequestStatusEnum.REJECTED_BY_REQUESTED, "mdi-close-circle-outline"],
  [RequestStatusEnum.REJECTED_BY_REQUESTING, "mdi-close-circle-outline"],
  [RequestStatusEnum.FINISHED, "mdi-check-bold"]
]);
